import styled from 'styled-components'
import { colors } from '@sabavision/dio'

const Container = styled.div`
  box-sizing: border-box;
  min-width: 100vw;
  min-height: 100vh;
  background: ${colors.cultured};
  font-family: IRANSans;

  * {
    box-sizing: border-box;
  }
`
export { Container }
